import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(() => ({
	preAnnouncement: {
		color: "#AFA08B",
		lineHeight: 1.2
	}
}));

export default styles;
